import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import {
	IQuestionnaireTemplateStateData,
	IQuestionnaireTemplateState,
} from 'src/features/questionnaire_template/domain/types';

import { ANNOTATION_TEMPLATE_LOADING_KEY } from './annotationTemplateThunks';

const initialState: IQuestionnaireTemplateState = {
	unsavedData: undefined,
};

export const annotationTemplateSlice = createSlice({
	name: ANNOTATION_TEMPLATE_LOADING_KEY,
	initialState,
	reducers: {
		setAnnotationUnsavedData: (
			state,
			action: PayloadAction<IQuestionnaireTemplateStateData>,
		) => {
			state.unsavedData = action.payload;
		},
		clearAnnotationUnsavedData: (state) => {
			state.unsavedData = undefined;
		},
	},
});

export const { setAnnotationUnsavedData, clearAnnotationUnsavedData } =
	annotationTemplateSlice.actions;
export default annotationTemplateSlice.reducer;
